<ng-template #monthCell let-row>
  @if (row.month === 'Total') {
    <strong>{{ 'FIELD_SEGMENTATION_YEAR_TO_DATE' | translate }}</strong>
  } @else {
    {{ row.month }}
  }
</ng-template>

<ng-template #statusCell let-row let-field="fieldName">
  @if (row.statuses[field]; as status) {
    <strong>{{ status.count }}</strong>
    @if (status.regions.length) {
      <ul class="region-counts">
        @for (entry of status.regions; track entry.id) {
          <li>
            <span>{{ (entry.region | serverTranslate:'names') || entry.id }}</span>
            <span>{{ entry.count }}</span>
          </li>
        }
      </ul>
    }
  }
</ng-template>

@if (report(); as report) {
  <section class="monthly-report">
    @if (report.regions.length) {
      <h3>{{ 'FIELD_SEGMENTATION_PROGRESS_BY_REGION' | translate }}</h3>
    }
    @for (region of report.regions; track region.id) {
      <details [open]="report.regions.length === 1">
        <summary>{{ (region | serverTranslate:'names') || region.id }}</summary>
        <app-data-table [columns]="columns()" [data]="region.rows" [config]="tableConfig" />
      </details>
    }
    <h3>{{ 'FIELD_SEGMENTATION_MONTHLY_PROGRESS' | translate }}</h3>
    @if (report.regions.length) {
      <p>{{ 'FIELD_SEGMENTATION_REGION_OVERLAP' | translate }}</p>
    }
    <app-data-table [columns]="columns()" [data]="report.overall" [config]="tableConfig" />
  </section>
}
